import { render } from "./SurveyQ10EnqRating.vue?vue&type=template&id=0fd2d011&ts=true"
import script from "./SurveyQ10EnqRating.vue?vue&type=script&lang=ts"
export * from "./SurveyQ10EnqRating.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__